import { render, staticRenderFns } from "./lv-table-body-item.vue?vue&type=template&id=71058c70&"
import script from "./lv-table-body-item.vue?vue&type=script&lang=js&"
export * from "./lv-table-body-item.vue?vue&type=script&lang=js&"
import style0 from "./lv-table-body-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports